/* eslint-disable react/jsx-no-duplicate-props */
import React, { Component } from 'react'

// redux
import { connect } from 'react-redux'
import actions from '../../redux/auth/actions'
import QuickMessageComponent from '../../components/QuickMessageComponent'
class QuickMessage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            username: '',
            password: '',
            isUnameEmpty: false,
            isPassEmpty: false,
        }
    }

    componentDidMount(){
        console.log('this.props.match', this.props.match)

    }

    render() {
        return (
            <div className="App">
                <QuickMessageComponent messid ={this.props.match}/>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        isLoggedIn: state.auth.isLoggedIn,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        login: (username, password) => {
            dispatch(actions.action.login(username, password))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(QuickMessage)
